var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 5.5V20C22 22.2 20.2 24 18 24H10.7C9.62 24 8.6 23.57 7.85 22.81L0 14.83C0 14.83 1.26 13.6 1.3 13.58C1.52 13.39 1.79 13.29 2.09 13.29C2.31 13.29 2.51 13.35 2.69 13.45C2.73 13.46 7 15.91 7 15.91V4C7 3.17 7.67 2.5 8.5 2.5C9.33 2.5 10 3.17 10 4V11H11V1.5C11 0.67 11.67 0 12.5 0C13.33 0 14 0.67 14 1.5V11H15V2.5C15 1.67 15.67 1 16.5 1C17.33 1 18 1.67 18 2.5V11H19V5.5C19 4.67 19.67 4 20.5 4C21.33 4 22 4.67 22 5.5Z",
    fill: "#81909E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/Offer.7cb21b99994c6fe9f2a30833e29d22d4.svg";
export { ForwardRef as ReactComponent };